import { Fragment } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useLomakedata } from "@/stores/lomakedata";
import Koulutusala from "./Koulutusala";
import {
  compose,
  equals,
  filter,
  length,
  map,
  prop,
  toUpper,
  where
} from "ramda";
import wizard from "@/i18n/definitions/wizard";
import Typography from "@mui/material/Typography";

const Tutkintokielet = ({ koulutusalat, maaraykset, mode }) => {
  const sectionId = "kielet_tutkintokielet";
  const intl = useIntl();

  const [tutkintodata] = useLomakedata({
    anchor: "tutkinnot"
  });

  return (
    <Fragment>
      <Typography component="h3" variant="h3">
        {intl.formatMessage(wizard.tutkintokielet)}
      </Typography>

      {map(koulutusala => {
        const aktiivisetTutkinnot = filter(
          compose(where({ isChecked: equals(true) }), prop("properties")),
          prop(koulutusala.koodiarvo, tutkintodata) || []
        );
        if (length(aktiivisetTutkinnot) || mode === "reasoning") {
          return (
            <Koulutusala
              aktiivisetTutkinnot={aktiivisetTutkinnot}
              key={koulutusala.koodiarvo}
              koodiarvo={koulutusala.koodiarvo}
              koulutusalakoodiarvo={koulutusala.koodiarvo}
              maaraykset={maaraykset}
              mode={mode}
              sectionId={`${sectionId}_${koulutusala.koodiarvo}`}
              title={`${koulutusala.metadata[toUpper(intl.locale)].nimi}`}
            />
          );
        } else {
          return null;
        }
      }, koulutusalat).filter(Boolean)}
    </Fragment>
  );
};

Tutkintokielet.propTypes = {
  koulutusalat: PropTypes.array,
  maaraykset: PropTypes.array,
  mode: PropTypes.string
};

export default Tutkintokielet;
